import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { testUrlConnectorConnection } from "../reducers";
import DoneIcon from "material-ui/svg-icons/action/done";
import ErrorIcon from "material-ui/svg-icons/alert/error";

class UrlConnector extends Component {
  constructor(props) {
    super(props);

    this.testConnection = this.testConnection.bind(this);
  }

  testConnection() {
    this.props.dispatch(testUrlConnectorConnection());
  }

  render() {
    const { valid, detail, loading } = this.props;

    let ResultMessage;
    if (valid === true) {
      ResultMessage = (
        <span>
          {" "}
          &nbsp;
          <DoneIcon />
          {detail || "Connection succeeded."}
        </span>
      );
    } else if (valid === false) {
      ResultMessage = (
        <span>
          {" "}
          &nbsp;
          <ErrorIcon />
          {detail || "Connection failed."}
        </span>
      );
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            URL Connector (UCCHUB)
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <p>
              Validates the configured urlConnector base URL and API key
              against a test shorten request, without sending a real message.
            </p>
          </Grid>
          <Grid item xs={12}>
            <Button
              id="test-urlconnector-connection"
              variant="contained"
              color="primary"
              disabled={loading}
              onClick={this.testConnection}
            >
              Test Connection
            </Button>
            {ResultMessage}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    valid: state.urlConnectorTest.valid,
    detail: state.urlConnectorTest.detail,
    loading: state.urlConnectorTest.loading
  };
};

export default connect(mapStateToProps)(UrlConnector);
